import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { LogOut, Menu, X, ShieldCheck } from 'lucide-react';

interface HeaderProps {
  isSidebarOpen: boolean;
  onSidebarToggle: () => void;
}

export function Header({ isSidebarOpen, onSidebarToggle }: HeaderProps) {
  const { user, profile, signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await signOut(navigate);
    } catch (error) {
      console.error('Error signing out:', error);
      // Force reload as fallback
      window.location.reload();
    }
  };

  return (
    <header className="bg-white shadow fixed top-0 z-50 w-full">
      <div className="mx-auto max-w-[1920px] px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            {user && (
              <button
                onClick={onSidebarToggle}
                className="lg:hidden p-2 -m-2 text-gray-600 hover:text-gray-900 transition-colors"
              >
                {isSidebarOpen ? (
                  <X className="h-6 w-6" />
                ) : (
                  <Menu className="h-6 w-6" />
                )}
              </button>
            )}
            <Link to="/" className="flex items-center gap-2">
              <img src="/favicon.svg" alt="Logo" className="h-8 w-8" />
              <span className="text-xl font-bold text-gray-900 whitespace-nowrap">
                Sano{' '}
                <span className="hidden sm:inline">
                  <span className="mx-2 text-gray-400">|</span>
                  <span className="text-lg text-gray-500">Clinical Documentation Assistant</span>
                </span>
              </span>
            </Link>
          </div>

          <div className="flex items-center gap-4 relative">
            {user ? (
              <div className="flex items-center gap-4">
                {profile?.is_admin && (
                  <Link
                    to="/app/admin"
                    className="flex items-center gap-1.5 rounded-md bg-amber-50 px-3 py-2 text-sm font-medium text-amber-700 hover:bg-amber-100 transition-colors"
                  >
                    <ShieldCheck className="h-4 w-4" />
                    <span>Admin</span>
                  </Link>
                )}
                <span className="text-sm text-gray-700">
                  {profile?.first_name ? `Hi, ${profile.first_name}` : user.email}
                </span>
                <button
                  onClick={handleSignOut}
                  className="flex items-center gap-2 rounded-md bg-gray-100 px-3 py-2 text-sm text-gray-700 hover:bg-gray-200 transition-colors"
                >
                  <LogOut className="h-4 w-4" />
                  <span>Sign Out</span>
                </button>
              </div>
            ) : (
              <div className="flex items-center gap-4 whitespace-nowrap">
                <Link
                  to="/auth"
                  className="text-gray-600 hover:text-gray-900 font-medium transition-colors"
                >
                  Sign In
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}